/**
 * Parse a CSV string into an array of objects.
 * Handles quoted fields with commas and escaped quotes.
 */
export function parseCsv(text) {
    const lines = [];
    let current = '';
    let inQuotes = false;

    for (let i = 0; i < text.length; i++) {
        const ch = text[i];
        if (inQuotes) {
            if (ch === '"') {
                current += '"';
                if (text[i + 1] === '"') {
                    current += '"';
                    i++;
                } else {
                    inQuotes = false;
                }
            } else {
                current += ch;
            }
        } else if (ch === '"') {
            inQuotes = true;
            current += '"';
        } else if (ch === '\n' || (ch === '\r' && text[i + 1] === '\n')) {
            lines.push(current);
            current = '';
            if (ch === '\r') i++;
        } else {
            current += ch;
        }
    }
    if (current) lines.push(current);

    if (lines.length === 0) return [];

    const splitRow = (line) => {
        const fields = [];
        let field = '';
        let quoted = false;
        for (let i = 0; i < line.length; i++) {
            const ch = line[i];
            if (quoted) {
                if (ch === '"' && line[i + 1] === '"') {
                    field += '"';
                    i++;
                } else if (ch === '"') {
                    quoted = false;
                } else {
                    field += ch;
                }
            } else if (ch === '"') {
                quoted = true;
            } else if (ch === ',') {
                fields.push(field);
                field = '';
            } else {
                field += ch;
            }
        }
        fields.push(field);
        return fields;
    };

    const headers = splitRow(lines[0]);
    return lines.slice(1).filter(l => l.trim()).map(line => {
        const values = splitRow(line);
        const row = {};
        headers.forEach((h, i) => { row[h] = (values[i] || '').trim(); });
        return row;
    });
}
